export default __webpack_public_path__ + "static/media/twitter.56273da3.svg";